import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { clone } from 'lodash';

@Component({
  selector: 'app-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.scss'],
})
export class ImageGalleryComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @Input('images') images = [] as any[];
  @Input('loading') loading = false;
  @Output('onImagesAdded') onImagesAdded: EventEmitter<File[]>;
  @Output('onImageRemoved') onImageRemoved: EventEmitter<any>;

  constructor() {
    this.onImagesAdded = new EventEmitter();
    this.onImageRemoved = new EventEmitter();
  }

  ngOnInit(): void {
    this.images = clone(this.images);
  }

  debug() {
    this.loading = true;
  }

  triggerFileInput(): void {
    this.fileInput.nativeElement.click(); // Programmatically trigger a click on the file input
  }

  removeImage(image, idx) {
    this.onImageRemoved?.emit(image);
    this.images.splice(idx, 1);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files) {
      this.onImagesAdded?.emit(Array.from(input.files));

      // Create FileReader for each selected file
      Array.from(input.files).forEach((image) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.images.push({ url: e.target.result }); // Store the image URL
        };
        reader.readAsDataURL(image); // Read the file as a data URL
      });
    }
  }
}
